/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StatisticsResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StatisticsResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ApiStatisticsResponse = factory(root.GisServerApis.ApiClient, root.GisServerApis.StatisticsResponse);
  }
}(this, function(ApiClient, StatisticsResponse) {
  'use strict';




  /**
   * The ApiStatisticsResponse model module.
   * @module model/ApiStatisticsResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ApiStatisticsResponse</code>.
   * The response for statistics groupped by API.
   * @alias module:model/ApiStatisticsResponse
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>ApiStatisticsResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ApiStatisticsResponse} obj Optional instance to populate.
   * @return {module:model/ApiStatisticsResponse} The populated <code>ApiStatisticsResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('api')) {
        obj['api'] = ApiClient.convertToType(data['api'], 'String');
      }
      if (data.hasOwnProperty('data')) {
        obj['data'] = ApiClient.convertToType(data['data'], [StatisticsResponse]);
      }
    }
    return obj;
  }

  /**
   * The API that the statisitcs are groupped by.
   * @member {String} api
   */
  exports.prototype['api'] = undefined;
  /**
   * A collection of statistics by API.
   * @member {Array.<module:model/StatisticsResponse>} data
   */
  exports.prototype['data'] = undefined;



  return exports;
}));



